export const copy = (value: string) => navigator.clipboard.writeText(value);
